export const ENABLE_ADGLARE_STATUS = 'ENABLE_ADGLARE_STATUS';
